import React from 'react';
import { Button } from '../button/button';
import { ButtonVariant, ButtonSize } from '../../core/enums';
import './start-coding-button.scss';

export interface StartCodingButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const StartCodingButton: React.FC<StartCodingButtonProps> = ({
  onClick,
  disabled = false,
  className = ''
}) => {
  return (
    <Button
      label="Start Coding"
      variant={ButtonVariant.PRIMARY}
      size={ButtonSize.MD}
      onClick={onClick}
      disabled={disabled}
      className={`cmx-start-coding-button ${className}`.trim()}
      dataTestId="start-coding-button"
    />
  );
};

StartCodingButton.displayName = 'StartCodingButton';
